import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

import Form from '../../../../components/forms/layout-form'
import Row from '../../../../components/forms/layout-row'
import Col from '../../../../components/forms/layout-column'
import Input from '../../../../components/forms/input'
import Button from '../../../../components/button'
import { VOUCHERS, FORM_MESSAGES } from '../../../../constants'
import styles from './add-voucher-form.css'

/**
 * AddVoucherForm
 *
 * Renders the voucher input form and submit action for the add-voucher flow.
 */
const AddVoucherForm = ({
  handleSubmit,
  onSubmit,
  control,
  errors,
  error,
  setError,
  isSubmitting
}) => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.header}>
        Do you have a voucher code?
        <br />
        Enter it here.
      </h1>

      <Form
        formClassName={styles.form}
        handleSubmit={handleSubmit(onSubmit)}
        isSubmitting={isSubmitting}
      >
        <Row>
          <Col>
            <Controller
              name="voucher"
              control={control}
              rules={{
                required: FORM_MESSAGES.required,
                minLength: {
                  value: VOUCHERS.CHAR_LIMIT,
                  message: `Voucher must be at least ${VOUCHERS.CHAR_LIMIT} characters`
                }
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  inputClass={styles.input}
                  onChange={(e) => {
                    field.onChange(e)
                    if (error) {
                      setError('')
                    }
                  }}
                  warning={errors?.voucher?.message || error}
                  warningClass={styles.warning}
                  exclamationClass={styles.exclamation}
                  data-e2e="add-voucher-form"
                />
              )}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              wrapperClassName={styles.buttonWrapper}
              text="Redeem"
              className={styles.button}
              disabled={isSubmitting}
            />
          </Col>
        </Row>
      </Form>
    </div>
  )
}

AddVoucherForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  control: PropTypes.object.isRequired,
  errors: PropTypes.shape({
    voucher: PropTypes.shape({
      message: PropTypes.string
    })
  }),
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}

AddVoucherForm.defaultProps = {
  errors: {}
}

export default AddVoucherForm
